import type { PayflowProgressBarData, PayflowProgressBarHandlers } from '@ctct/application-layer';
import { ProgressBar } from '@ctct/payflow-ui';
import { type PayflowProgressBarHooks } from '@ctct/state-client-layer';

interface Props {
  data: PayflowProgressBarData;
  handlers: PayflowProgressBarHandlers;
  hooks: PayflowProgressBarHooks;
}

export const PayflowProgressBarWidgetContent = ({ data, handlers, hooks }: Props) => {
  const isMWebVariantEnabled = data.getIsMWebVariantEnabled();
  const isValueFocusedMWebPlanSelectionEnabled = data.getIsValueFocusedMWebPlanSelectionEnabled();

  const isHidden = hooks.useIsHidden() || (isMWebVariantEnabled && !isValueFocusedMWebPlanSelectionEnabled);
  const activeStepId = hooks.useActiveStepId();

  // translate step labels
  const steps = data.getSteps(activeStepId);

  if (isHidden) {
    return null;
  }

  return <ProgressBar steps={steps} onStepClick={handlers.onStepClick} />;
};
